import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../Api/CommonApi";
import { api } from "../../Api/AuthApi";

export const create_policy = createAsyncThunk(
    "create_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.create_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const update_policy = createAsyncThunk(
    "update_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.update_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const get_all_policy = createAsyncThunk(
    "get_all_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.get_all_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const active_inActive_policy = createAsyncThunk(
    "active_inActive_policy",
    async (body: unknown) => {
        return await ApiPostNoAuth(api.active_inActive_policy, body)
            .then(async (res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);


export const get_policy_by_code = createAsyncThunk(
    "get_policy_by_code",
    async (id: string, { rejectWithValue }) => {
        return await ApiGetNoAuth(`${api.get_policy_by_code}/${id}`)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => rejectWithValue(err));
    }
);